import type { ChatMessage } from '@bosmart/types'
import { logger } from '@/lib/logging'
import type { SessionRefs } from './types'

export function buildTurnMessages(userText: string, modelText: string): ChatMessage[] {
  const messages: ChatMessage[] = []
  const timestamp = new Date().toISOString()

  if (userText.trim()) messages.push({ role: 'user', text: userText, timestamp })
  if (modelText.trim()) messages.push({ role: 'model', text: modelText, timestamp })

  return messages
}

export function trackQuestionProgress(refs: SessionRefs, userText: string, modelText: string) {
  if (!userText.trim() || !modelText.trim() || !refs.serviceRef.current) return

  try {
    const currentState = refs.serviceRef.current.getInterviewState()
    if (
      currentState.currentQuestionIndex < 0 ||
      currentState.currentQuestionIndex >= currentState.totalQuestions
    ) {
      return
    }

    const currentQuestion = refs.serviceRef.current.getCurrentQuestion()
    if (!currentQuestion || currentState.answeredQuestions.includes(currentQuestion.id)) return

    refs.serviceRef.current.markQuestionAnswered(currentQuestion.id)
    refs.serviceRef.current.addQuestionAnswerToMemory(
      currentQuestion.id,
      currentQuestion.prompt,
      userText
    )

    if (import.meta.env.DEV) {
      logger.info(
        `[QUESTION TRACKING] Marked question ${currentState.currentQuestionIndex + 1} as answered`
      )
    }
  } catch (err) {
    if (import.meta.env.DEV) {
      logger.warn('Failed to track question progression', { error: String(err) })
    }
  }
}
